import React, { useEffect, useState } from 'react';
import { MdClose } from 'react-icons/md';
import { LuPrinter } from "react-icons/lu";
import { FiExternalLink } from "react-icons/fi";
import { getGmailEmailDetailsFromDB, getOutlookEmailThread, getOutlookEmailDetailsFromDB, getGmailEmailThread } from "../../services/api"
import toast from 'react-hot-toast';
import { DataState } from '../../context/DataProvider';
import { FiMinimize } from "react-icons/fi";
import { Link } from 'react-router-dom';
import TriggerForm from '../form/TriggerForm';
import EmailConversation from './EmailConversation';
import EmailIframe from '../chat/EmailIframe';
import { convertToIST } from '../../utils/dateTimeUtils';
import EmailContent from './EmailContent';




function parseEmailList(emailString) {
  const emailObjects = emailString.split(/,\s*/).map(entry => {
    // Match cases with quotes for the email: `"email@example.com" <email@example.com>`
    const quotedEmailMatch = entry.match(/^"([^"]+)"\s*<([^>]+)>$/);
    if (quotedEmailMatch) {
      const email = quotedEmailMatch[2];
      return { name: quotedEmailMatch[1], email };
    }


    // Match cases with name and email: `Name <email@example.com>`
    const nameEmailMatch = entry.match(/^(.+?)\s*<([^>]+)>$/);
    if (nameEmailMatch) {
      const name = nameEmailMatch[1].trim();
      const email = nameEmailMatch[2].trim();
      return { name, email };
    }


    return { name: entry.trim(), email: entry.trim() }; // Handle unexpected formats gracefully
  }).filter(Boolean); // Remove invalid entries

  return emailObjects;
}

const SkeletonLoader = ({ type = 'text' }) => {
  if (type === 'text') {
    return (
      <div className="mr-4 space-y-4">
        <div className="w-full h-6 bg-gray-300 rounded animate-pulse"></div>
        <div className="w-3/4 h-6 bg-gray-300 rounded animate-pulse"></div>
        <div className="w-1/2 h-6 bg-gray-300 rounded animate-pulse"></div>
      </div>
    );
  }
  if (type === 'emailbody') {
    return (
      <div className="mr-4 space-y-4">
        <div className="w-full h-6 bg-gray-300 rounded animate-pulse"></div>
        <div className="w-3/4 h-6 bg-gray-300 rounded animate-pulse"></div>
        <div className="w-1/2 h-6 bg-gray-300 rounded animate-pulse"></div>
        <div className="w-3/4 h-6 bg-gray-300 rounded animate-pulse"></div>
        <div className="w-1/2 h-6 bg-gray-300 rounded animate-pulse"></div>
        <div className="w-3/4 h-6 bg-gray-300 rounded animate-pulse"></div>
        <div className="w-1/2 h-6 bg-gray-300 rounded animate-pulse"></div>
      </div>
    );
  }

  if (type === 'image') {
    return (
      <div className="w-full h-48 mr-4 bg-gray-300 rounded-lg animate-pulse"></div>
    );
  }

  if (type === 'card') {
    return (
      <div className="w-full max-w-sm p-4 mr-4 space-y-4 bg-white rounded-lg shadow-md">
        <div className="w-full h-32 bg-gray-300 rounded-lg animate-pulse"></div>
        <div className="h-6 bg-gray-300 rounded animate-pulse"></div>
        <div className="w-3/4 h-6 bg-gray-300 rounded animate-pulse"></div>
      </div>
    );
  }

  return null;
};

const EmailComponent = ({ messageId, analytics, onClose, isOutlook, isDialog = false, isAnalyticsView, setIsAnalyticsView, isGmail }) => {
  console.log("analytics", analytics, isOutlook);
  const [email, setEmail] = useState({});
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [conversationLoading, setConversationLoading] = useState(true);

  const [outlookEmailThread, setOutlookEmailThread] = useState([]);


  const [isModalOpen, setModalOpen] = useState(false);
  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);




  const {
    userGoogleId
  } = DataState();

  useEffect(() => {
    const setMessageDetails = async () => {
      if (!messageId) {
        return;
      }

      try {
        let message_data = null;
        if (isOutlook) {
          message_data = await getOutlookEmailDetailsFromDB(messageId, userGoogleId);
        } else {
          message_data = await getGmailEmailDetailsFromDB(messageId, userGoogleId);
        }

        console.log("Message Data:", { ...message_data })

        const { time, date } = convertToIST(message_data.date);
        message_data.time = time;
        message_data.date = date;
        // if (!isOutlook) {
        //   message_data.from = parseEmailList(message_data.from)
        //   message_data.to = parseEmailList(message_data.to)
        // } else {
        message_data.from.email = message_data.from?.address || message_data.from?.contact;
        message_data.from = [message_data.from]
        message_data.to = message_data.to?.map(to => {
          return { ...to, email: (to.address || to.contact) }
        })
        message_data.attachments = (message_data.attachments || []).map(attachment => {
          return { ...attachment, mimeType: attachment.contentType, attachmentId: attachment.id, filename: attachment.name }
        })
        // }
        console.log("Message Data After Update:", message_data)
        setEmail(message_data)
        setLoading(false)


      } catch (error) {
        console.log("Error while fecthing message details:", error);
        // toast.error(error);
        setLoading(false);
      }
    }
    setMessageDetails();


  }, [messageId])

  const toggleView = () => {
    setIsAnalyticsView(!isAnalyticsView);
  };

  useEffect(() => {
    setConversationLoading(true);
    const fetchEmailConversations = async () => {
      try {
        let response = null;
        if (isOutlook) {
          response = await getOutlookEmailThread(userGoogleId, email?.conversationId);
        } else {
          response = await getGmailEmailThread(userGoogleId, email?.conversationId);
        }
        console.log("getOutlookEmailConversations:", response);
        if (response?.emails?.length > 0) {
          setOutlookEmailThread(response.emails);
          setConversationLoading(false);
        }
        if (response?.emails?.length > 0) {
          setOutlookEmailThread(response.emails);
          setConversationLoading(false);
        }
      } catch (error) {
        console.error("API Error:", error);
        setConversationLoading(false);
      }
    };

    if (email) {
      fetchEmailConversations();
    }
  }, [email]);

  return (
    <div
      className={`${isDialog
        ? "flex justify-center"
        : "fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 backdrop-blur-sm"
        }`}
      onClick={isDialog ? onClose : undefined}
    >

      <div
        className={`flex flex-col bg-gray-100 pt-2 pl-2 pr-6 min-h-[300px] ${isDialog ? "w-full" : "w-2/3"} rounded-lg shadow-md`}
        onClick={(e) => e.stopPropagation()}
      >
        <TriggerForm isModalOpen={isModalOpen} closeModal={closeModal} isDialog={true} />

        <div className="flex flex-row w-full mt-2">

          <div className="flex flex-col w-full">
            <div className="flex flex-col justify-between w-full mb-2 sm:flex-row sm:items-center">
              {loading ? (
                <div className="h-6 mb-2 ml-2 bg-gray-300 rounded w-72 sm:w-96 sm:ml-12 animate-pulse sm:mb-0" />
              ) : (
                <h2 className="mb-2 text-lg font-semibold text-gray-900 sm:ml-12 sm:text-xl sm:mb-0">
                  {isAnalyticsView ? "Email Analytics" : email.subject || "No Subject"}
                </h2>
              )}

              <div className="flex flex-wrap items-center gap-2 max-sm:justify-between sm:gap-4 sm:mr-4">
                <button
                  className={`px-3 py-1 text-sm text-white rounded flex items-center justify-center transition ${loading ? "h-6 w-14 bg-gray-300 animate-pulse" : "bg-zinc-500 hover:bg-zinc-600"
                    }`}
                  onClick={toggleView}
                  disabled={loading}
                >
                  {loading ? "" : isAnalyticsView ? "View Email" : "AI View"}
                </button>

                <div className="flex items-center gap-2">

                {/* {loading ? (
                  <div className="w-6 h-6 bg-gray-300 rounded animate-pulse"></div>
                ) : (
                  <button className="text-gray-500 hover:text-gray-700">
                    <LuPrinter size={20} />
                  </button>
                )} */}

                {loading ? (
                  <div className="w-6 h-6 bg-gray-300 rounded animate-pulse"></div>
                ) : (
                  <Link
                    target="_blank"
                    to={isOutlook ? email?.webLink : `https://mail.google.com/mail/u/0/#all/${messageId}`}
                  >
                    <button className="text-gray-500 hover:text-gray-700">
                      <FiExternalLink size={20} />
                    </button>
                  </Link>
                )}

                <button
                  className="text-gray-500 hover:text-gray-700"
                  onClick={() => {
                    setIsAnalyticsView(false);
                    onClose();
                  }}
                >
                  <MdClose size={20} />
                </button>
                </div>
              </div>
            </div>
            <EmailContent
              email={email}
              emailThread={outlookEmailThread}
              loading={loading}
              isAnalyticsView={isAnalyticsView}
              messageId={messageId}
              isDialog={isDialog}
              isOutlook={isOutlook}
              setIsFullScreen={setIsFullScreen}

            />
            {conversationLoading ? (
              <div className="w-full h-6 bg-gray-300 rounded animate-pulse"></div>
            )
              :
              (
                outlookEmailThread.slice(1).length > 0 &&
                <EmailConversation
                  outlookEmailThread={outlookEmailThread.slice(1)}
                  setLoading={setConversationLoading}
                  loading={conversationLoading}
                />
              )
            }

          </div>
        </div>

      </div>

      {
        isFullScreen && (
          <div className="fixed inset-0 z-50 w-screen h-screen p-6 bg-white">
            {/* Close button stays fixed at top-right */}
            <button
              className="absolute p-2 mb-4 text-gray-500 transition-all transform bg-gray-200 rounded-full bottom-8 right-14 hover:bg-gray-300 hover:text-gray-700 hover:scale-110"
              onClick={(e) => {
                e.stopPropagation();
                setIsFullScreen(false);
              }}
            >
              <FiMinimize size={24} />
            </button>

            {/* Scrollable content */}
            <div
              onClick={(e) => e.stopPropagation()}
              className="h-full overflow-y-hidden scrollbar-thumb-gray-500 scrollbar-track-gray-200">
              {/* <article
                dangerouslySetInnerHTML={{ __html: email.body }}
                className="text-gray-700 whitespace-pre-line"
              /> */}
              <EmailIframe emailBody={email.body}></EmailIframe>
            </div>
          </div>
        )
      }

    </div >
  );
};


export default EmailComponent;